import React, {useEffect, useState} from 'react';

import AnimatedDotsComponent from './animatedDotsComponent';
import ParticipantChatNameComponent from '../../chatComponents/participantChatNameComponent';

import './typingComponent.css';

const TypingComponent = ({
  isMentor = false,
  showMultipleUserUI = false,
  participantsInfo = {},
  typingParticipantsInfo = [],
}) => {
  const [typingTxt, setTypingTxt] = useState(null);

  useEffect(() => {
    let typingTxt;
    if (participantsInfo && typingParticipantsInfo) {
      const names = typingParticipantsInfo.map(
        (participant) =>
          participantsInfo[participant.senderObjectId]?.participantName,
      );
      if (names.length) {
        if (names.length === 1) {
          typingTxt = names[0] + ' is typing ...';
        } else {
          const lastParticipant = names.pop();
          typingTxt =
            `${names.join(', ')} and ${lastParticipant}` + ' are typing ...';
        }
      }
    }
    setTypingTxt(typingTxt);
  }, [participantsInfo, typingParticipantsInfo]);

  return (
    <>
      {showMultipleUserUI ? (
        typingTxt && (
          <div className="et-v2-typing-component-container">
            <AnimatedDotsComponent isMentor={isMentor} />
            <div className="et-chatting-chat-row et-chat-left-blue">
              <ParticipantChatNameComponent participantName={typingTxt} />
            </div>
          </div>
        )
      ) : isMentor ? (
        <div className="et-chatting-chat-row et-chat-left-blue et-more-chat">
          <span className="et-chatting-chat-row-span et-chat-peer-typing-wrap">
            <i className="et-v2-tcc-dot fas fa-circle" />
            <i className="et-v2-tcc-dot fas fa-circle" />
            <i className="et-v2-tcc-dot fas fa-circle" />
          </span>
        </div>
      ) : (
        <div
          className={`et-dot-box-wrap  ${!isMentor ? 'et-v2-tcc-customer' : ''}`}>
          <span className="et-more-chat et-box-align-left-msg et-chat-peer-typing-wrap">
            <i className="et-v2-tcc-dot fas fa-circle" />
            <i className="et-v2-tcc-dot fas fa-circle" />
            <i className="et-v2-tcc-dot fas fa-circle" />
          </span>
        </div>
      )}
    </>
  );
};

export default TypingComponent;
